export enum ROLES {
    ADMIN = 'admin',
    HELPER = 'helper',
}

export enum TASK_STATUS {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    IN_APPLICATION = 'in_application',
    ASSIGNED = 'assigned',
    PROGRESS = 'progress',
    COMPLETE = 'complete',
    REJECTED = 'rejected'
 }

export const DAY_NAMES = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
export const MONTH_NAMES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export const MOBILE_SIZE_SUPPORT = '(max-width: 768px)'